import type { ThreadSchema } from "@/stores/threads-store";

export const isDraftThread = (thread: ThreadSchema) =>
    !thread.kind && !thread.is_discussion;
